import { AppDispatch, AppState } from "src/features";

import { Rating } from "../../../sharedComponents";
import { showModalMessage } from "../../modalMessage/actions/show";
import { modalMessages } from "../../modalMessage/messages";
import { sendSurvey } from "../../survey/actions/sendSurvey";
import { actionCreators as surveyActionCreators } from "../../survey/reducers/survey";
import { getRating } from "../../survey/selectors/rating";
import { getSurveyDetails } from "../../survey/selectors/survey";
import { actionCreators } from "../reducers/payOnlyFlags";
import { showGetReceipt } from "./showGetReceipt";
import { getIsPayOnlyTable } from "src/features/openTable/selectors";

const toggleGoogleReviewClass = (show: boolean): void => {
    if (show) {
        document.body.classList.add("has-google-review");
    } else {
        document.body.classList.remove("has-google-review");
    }
};

export const showFeedback = () => {
    return (dispatch: AppDispatch) => {
        window.setTimeout(() => dispatch(actionCreators.setShowFeedback(true)), 3000);
    };
};

export const showGoogleReviewFeedback = () => {
    return async (dispatch: AppDispatch, getState: () => AppState) => {
        const state = getState();
        const surveyDetails = getSurveyDetails(state);
        const isGoogleReviewsEnabled = surveyDetails?.googleReviewsSettings?.enabled;
        const isPayOnlyTable = getIsPayOnlyTable(state);

        if ((isPayOnlyTable && !surveyDetails) || !isGoogleReviewsEnabled) {
            dispatch(showGetReceipt());
            return;
        }

        if (!surveyDetails || !isGoogleReviewsEnabled) {
            return;
        }
        toggleGoogleReviewClass(true);

        dispatch(
            showModalMessage(
                modalMessages.feedbackSurvey({
                    hasSurveyDetails: true,
                    isGoogleReviewsEnabled,
                    action: () => {
                        const rating = getRating(getState());
                        dispatch(
                            showModalMessage(
                                modalMessages.feedbackSurvey({
                                    hasSurveyDetails: true,
                                    shouldValidate: true,
                                    initialValid: rating === Rating.POSITIVE,
                                    primaryAction: () => {
                                        const currentRating = getRating(getState());
                                        if (currentRating === Rating.NEGATIVE && isGoogleReviewsEnabled) {
                                            dispatch(sendSurvey(true));
                                            return;
                                        }
                                        if (isGoogleReviewsEnabled) {
                                            dispatch(surveyActionCreators.resetSurvey());
                                            dispatch(actionCreators.setShowFeedback(false));
                                            toggleGoogleReviewClass(false);
                                        } else {
                                            dispatch(sendSurvey());
                                        }
                                    },
                                    isGoogleReviewsEnabled: true,
                                    isPayOnly: isPayOnlyTable
                                })
                            )
                        );
                    },
                    primaryAction: () => {
                        dispatch(surveyActionCreators.resetSurvey());
                        dispatch(actionCreators.setShowFeedback(false));
                        toggleGoogleReviewClass(false);
                    },
                    isPayOnly: isPayOnlyTable
                })
            )
        );
    };
};
